export default {
  'activity': 'Activiteit',
  'amount': 'Aantal',
  'back': 'Terug',
  'create': 'Aanmaken',
  'cancel': 'Annuleren',
  'date': 'Datum',
  'debug_and_tracking': 'Debug & tracking',
  'delete': 'Verwijderen',
  'destroy': 'Verwijderen',
  'duration': 'Duur',
  'edit': 'Wijzigen',
  'edit_entry': 'Wijzig registratie',
  'employee': 'Werknemer',
  'end': 'Geëindigd',
  'info': 'Info',
  'in_progress': 'Bezig',
  'last_entries': 'Laatste registraties',
  'menu': 'Menu',
  'no_packagings_yet': 'Er zijn nog geen verpakkingen toegevoegd',
  'no_registrations_yet': 'Er zijn nog geen registraties gedaan',
  'packaging': 'Verpakkingstype',
  'row': 'Rij',
  'rows': 'Rijen',
  'rows_as_buttons': 'Toon rijen als knoppen',
  'row_status': 'Rijstatus',
  'row_percentage': 'Rij percentage',
  'save': 'Opslaan',
  'select': 'Selecteer',
  'select_a_packaging': 'Selecteer een verpakkingstype',
  'select_a_row': 'Selecteer een rij',
  'select_a_row_status': 'Selecteer een rijstatus',
  'select_a_row_percentage': 'Selecteer een rij percentage',
  'select_a_team': 'Selecteer een team',
  'select_an_activity': 'Selecteer een actiteit',
  'select_an_employee': 'Selecteer een werknemer',
  'start': 'Gestart',
  'store': 'Opslaan',
  'synchronise': 'Synchroniseren',
  'synchronise_settings': 'Instellingen synchroniseren',
  'version': 'Versie',

  'device': 'Apparaat',
  'device_name': 'Apparaatnaam',
  'register_device': 'Registreer apparaat',
  'registers': 'Registreert',
  'email': 'E-mailadres',
  'password': 'Wachtwoord',
  'remember_me': 'Onthoud mij',
  'login': 'Inloggen',
  'logout': 'Uitloggen',
  'location': 'Locatie | Loaties',
  'select_location': 'Selecteer een locatie',
  'name': 'Naam',
  'register_workdays': 'Registreer werkdagen',
  'register_activities': 'Registreer activiteiten',
  'pre_register_activities': 'Activiteiten vooraf registreren',
  'pre_registers': 'Registreert vooraf',

  'enter_pin': 'Voer uw pincode in',

  'workdays': 'Werkdagen',
  'start_workday': 'Begin werkdag',
  'end_workday': 'Beëindig werkdag',
  'break': 'Pauze',
  'start_break': 'Begin pauze',
  'end_break': 'Beëindig pauze',

  'activities': 'Activiteiten',
  'select_activity': 'Selecteer een activiteit',
  'select_packaging': 'Selecteer een verpakkingstype',
  'select_row': 'Voer rijnummer in',
  'enter_team': 'Selecteer team',
  'enter_row_status': 'Selecteer rijstatus',
  'enter_row_percentage': 'Selecteer rij percentage',
  'enter_amount': 'Voer aantal in',

  'close': 'Sluiten',
  'edit_activities': 'Wijzig weergave activiteiten',
  'edit_rows': 'Wijzig weergave rijen',
  'edit_teams': 'Wijzig weergave teams',

  'sort_activities': 'Sorteer activiteiten',
  'sort_rows': 'Sorteer rijen',
  'sort_teams': 'Sorteer teams',
  'to_approve': 'Te accorderen',
  'confirm_sync': 'Er staan nog activiteiten open. Als u nu synchroniseert worden deze activiteiten afgesloten.',
  'hidden': 'Verborgen',
  'shown': 'Getoond',
  'reset': 'Reset',
  'uuid': 'Device ID',
  'team': 'Team',
  'teams': 'Teams',
  'teams_as_buttons': 'Toon teams als knoppen',
  'settings': 'Instellingen',
  'pin_visible': 'PIN zichtbaar',
  'dark_mode': 'Dark mode',
  'choose_existing_device': 'Kies een bestaand apparaat',
  'create_new_device': 'Maak een nieuw apparaat aan',
  'select_device': 'Kies een apparaat'
}
